const nativeEmbedPaths = [
  /\/privacy\/{0,1}$/g,
  /\/my-privacy\/{0,1}$/g,
  /\/profile-privacy\/{0,1}$/g,
  /\/terms\/{0,1}$/g,
  /\/safe-job-searching\/{0,1}$/g,
  /\/collection-notice\/{0,1}$/g,
];

export default (path: string): string => {
  if (nativeEmbedPaths.some((e) => path.match(e))) {
    // Initial tests are positive, lets do the magic
    // Interestingly Asia and AU links support the same
    return `${path}?native-embed=true`;
  }
  // Safe cheat
  return path;
};
